import dompurify from 'dompurify';

export const sanitizer = dompurify.sanitize;
